import FileUpload from "vue-upload-component";

// vue-upload-component types `capture` as [Boolean, String], so Vue casts an omitted prop to
// false and renders capture="false". Any capture attribute makes iOS open the camera instead
// of offering the photo library, so an omitted prop has to stay off the input.
export default {
  name: "FileUpload",
  extends: FileUpload,
  props: {
    capture: { type: [Boolean, String], default: undefined },
  },
};
